(function ($){
    const $body = $('body')
    const $menuCat = $body.find('.header__mobile-catmenu-nav')
    const $menuCatToggle = $body.find('#toggle-categories')

    const activeMenuClass = '_is-cat-menu-show'
    const activeToggleClass = '_active'

    const $mobileMenuToggle = $body.find('#toggle-mobile-menu')

    $(document).on('click', function (){
        $body.removeClass(activeMenuClass)
        $menuCatToggle.removeClass(activeToggleClass)
    })

    $menuCat.on('click', function (e){
        e.stopPropagation()
    })

    $menuCatToggle.on('click', function (e){
        e.preventDefault()
        e.stopPropagation()

        $menuCatToggle.toggleClass(activeToggleClass)

        $body.toggleClass(activeMenuClass)
    })

    $mobileMenuToggle.on('click', function (e){
        e.preventDefault()

        $mobileMenuToggle.toggleClass(activeToggleClass)

        $body.toggleClass('_is-menu-show')
    })
})(jQuery)
